import { render, staticRenderFns } from "./TopNotifications.vue?vue&type=template&id=21cbe23c"
import script from "./TopNotifications.vue?vue&type=script&lang=js"
export * from "./TopNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports